// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"c94ddc6f","124":"fb12c98c","277":"1b549b5c","353":"9a7cc7f5","449":"b0d9d91d","453":"703d9625","660":"26a53d6c","697":"35f57cc4","712":"cee23596","819":"927e1b88","977":"4dcb2863"}[chunkId] + ".chunk.js";
};